export default __webpack_public_path__ + "assets/images/668809ce58740098dc4d7fc9ddf1f67b.png";